import { CLEAR_STORE } from 'modules/auth/types';
import auth from 'modules/auth/reducer';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';
import location from 'modules/location/reducer';
import locationStation from 'modules/location-station/reducer';
import me from 'modules/me/reducer';
import modal from 'modules/modal/reducer';
import nav from 'modules/nav/reducer';
import { persistReducer } from 'redux-persist';
import regions from 'modules/regions/reducer';
import selectVideo from 'modules/form/select-video/reducer';
import staff from 'modules/staff/reducer';
import stationStatus from 'modules/station-equipments/reducer';
import stations from 'modules/stations/reducer';
import video from 'modules/video/reducer';
import workoutProgram from 'modules/workout-program/reducer';
import { rootPersistConfig } from './persistor';
import history from './history';

const appReducer = combineReducers({
  // external
  router: connectRouter(history),
  form,

  // app
  auth,
  video,
  me,
  nav,
  modal,
  regions,
  stations,
  stationStatus,
  locationStation,
  location,
  selectVideo,
  workoutProgram,
  staff,
});

const actions = [CLEAR_STORE];

const rootReducer = (state, action) => {
  if (actions.includes(action.type)) {
    const { router } = state;
    return appReducer({ router }, action);
  }

  return appReducer(state, action);
};

export default persistReducer(rootPersistConfig, rootReducer);
